// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Copyright[data-v-8c3f41f2]{position:fixed;width:100%;margin-top:100px;background-color:#212121;height:40px;line-height:40px;padding:10px 0;text-align:center;bottom:0;z-index:999}.Copyright span[data-v-8c3f41f2]{color:#a09b9f;font-size:14px;text-align:center}.Copyright span a[data-v-8c3f41f2]{color:#409efe;font-size:14px;text-decoration:none}", ""]);
// Exports
module.exports = exports;
